function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 44 50",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "rgb(0, 83, 160)",
      stroke: "rgba(0, 0, 0, 0)"
    },
    height: 15.261,
    transform: "matrix(0.989001, 0.147912, -1.086593, 0.848614, -18.570875, 33.579991)",
    x: 27.748,
    y: -9.087,
    width: 27.557
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "rgb(0, 83, 160)",
      stroke: "rgb(67, 74, 87)",
      strokeWidth: "0.3px"
    },
    height: 15.261,
    transform: "matrix(0.989, 0.147912, -1.086593, 0.848614, -18.734612, 30.575507)",
    x: 27.748,
    y: -9.087,
    width: 27.557
  }), /*#__PURE__*/React.createElement("rect", {
    x: 41.728,
    y: 8.384,
    width: 4,
    height: 26,
    style: {
      fill: "rgb(0, 83, 160)",
      stroke: "rgba(0, 0, 0, 0)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    y: 17.152,
    width: 4,
    height: 26,
    style: {
      fill: "rgb(0, 83, 160)",
      stroke: "rgba(0, 0, 0, 0)"
    },
    x: 2.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26.5,
    y: 20.041,
    width: 4,
    height: 26,
    style: {
      fill: "rgb(0, 83, 160)",
      stroke: "rgb(67, 74, 87)",
      paintOrder: "fill",
      strokeWidth: "0.3px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17.308,
    width: 4,
    height: 26,
    style: {
      fill: "rgb(0, 83, 160)",
      stroke: "rgba(0, 0, 0, 0)"
    },
    y: 3
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCp);
export default __webpack_public_path__ + "static/media/cp.1343780b5f3477fe72957d0c89ea1df1.svg";
export { ForwardRef as ReactComponent };